document.addEventListener('DOMContentLoaded', function () {
    const config = window.seatsioConfig;
    if (!config) return;

    const widgetElement = document.getElementById('seatsio-chart-widget');
    const selectedContainer = document.getElementById('selected-objects');
    const holdTimerEl = document.getElementById('hold-timer');
    const sessionExpiredOverlay = document.getElementById('seatsio-session-expired-overlay');
    const sessionExpiredBtn = document.getElementById('seatsio-session-expired-overlay__btn');
    const selectedIds = new Set();

    let holdTimerInterval = null;
    let chart = null;
    const priceFormatter = new Intl.NumberFormat('ru-RU');
    const selectedObjects = new Map();

    function showChart() {
        if (widgetElement) {
            widgetElement.style.display = 'block';
        }
        const eventInfoCard = document.querySelector('.event-info-aside__card');
        if (eventInfoCard) {
            eventInfoCard.style.display = 'none';
        }
        const buyerSeatsioExtended = document.querySelector('.buyer-seatsio-extended');
        if (buyerSeatsioExtended) {
            buyerSeatsioExtended.style.display = 'block';
        }
        initChart();
    }

    function hideChart() {
        if (widgetElement) {
            widgetElement.style.display = 'none';
        }
        const eventInfoCard = document.querySelector('.event-info-aside__card');
        if (eventInfoCard) {
            eventInfoCard.style.display = 'block';
        }
        const buyerSeatsioExtended = document.querySelector('.buyer-seatsio-extended');
        if (buyerSeatsioExtended) {
            buyerSeatsioExtended.style.display = 'none';
        }
    }

    window.seatsioHelper = {
        getSeatParts: getSeatParts,
        getCategoryKey: getCategoryKey,
        findPriceByCategoryKey: findPriceByCategoryKey,
        initChart: initChart,
        getChart: function () {
            return chart;
        },
        getSelectedObjects: function () {
            return selectedObjects;
        },
        getPriceFormatter: function () {
            return priceFormatter;
        },
        showChart: showChart,
        hideChart: hideChart
    };

    function updateTotalPrice() {
        if (typeof priceFormatter === 'undefined') return;

        const detail = {
            selectedObjects: selectedObjects,
            config: config,
            priceFormatter: priceFormatter
        };

        document.dispatchEvent(new CustomEvent('seatsioTotalPriceUpdate', {
            detail: detail
        }));

        if (window.appliedPromoCode) {
            document.dispatchEvent(new CustomEvent('promoCodeApplied', {
                detail: window.appliedPromoCode
            }));
        }
    }

    function initChart() {
        if (chart) return;

        const sessionKey = `seatsio_expires_at_${config.event}`;
        const expiresAtStr = localStorage.getItem(sessionKey);
        let sessionMode = 'continue';

        if (expiresAtStr) {
            const expiresAt = Date.parse(expiresAtStr);
            if (isNaN(expiresAt) || expiresAt <= Date.now()) {
                sessionMode = 'start';
            }
        } else {
            sessionMode = 'start';
        }

        chart = new seatsio.SeatingChart({
            divId: 'event-chart',
            workspaceKey: config.workspaceKey,
            event: config.event,
            mode: 'normal',
            session: sessionMode,
            pricing: {
                prices: config.prices ?? false,
                priceFormatter: function (price) {
                    return priceFormatter.format(price) + ' ' + config.currencySymbol;
                }
            },
            language: config.language || 'ru',
            objectPopover: {
                showAvailability: true,
                showLabel: true,
                showPricing: true,
                showUnavailableNotice: true,
                stylizedLabel: true,
                confirmSelection: 'always'
            },
            onHoldTokenExpired: function () {
                localStorage.removeItem(`seatsio_expires_at_${config.event}`);
                if (holdTimerInterval) {
                    clearInterval(holdTimerInterval);
                    holdTimerInterval = null;
                }
                hideHoldTimer();
                showSessionExpiredOverlay();
                selectedIds.clear();
                selectedObjects.clear();
                updateTotalPrice();
            },
            onSessionInitialized: function (session) {
                try {
                    const expiresAt = session?.expiresAt || null;
                    const sessionKey = `seatsio_expires_at_${config.event}`;
                    if (expiresAt) {
                        localStorage.setItem(sessionKey, expiresAt);
                        startHoldCountdown(expiresAt);
                    } else {
                        localStorage.removeItem(sessionKey);
                        hideHoldTimer();
                    }
                } catch (e) {
                    hideHoldTimer();
                }
            },
            onObjectSelected: function (object) {
                addSeatTile(object);
                if (object?.id) {
                    selectedIds.add(object.id);
                    selectedObjects.set(object.id, object);
                }
                showHoldTimer();
                updateTotalPrice();
            },
            onObjectDeselected: function (object) {
                removeSeatTile(object.id);
                if (object?.id) {
                    selectedIds.delete(object.id);
                    selectedObjects.delete(object.id);
                }
                updateTotalPrice();
            },
            onRenderFinished: function (chart) {
                chart.listSelectedObjects(function (objects) {
                    if (objects.length > 0) {
                        if (widgetElement) {
                            widgetElement.style.display = 'block';
                        }

                        const buyerSeatsioExtended = document.querySelector('.buyer-seatsio-extended');
                        if (buyerSeatsioExtended) {
                            buyerSeatsioExtended.style.display = 'block';
                        }

                        const eventInfoCard = document.querySelector('.event-info-aside__card');
                        if (eventInfoCard) {
                            eventInfoCard.style.display = 'none';
                        }

                        objects.forEach(function (object) {
                            addSeatTile(object);
                            if (object?.id) {
                                selectedIds.add(object.id);
                                selectedObjects.set(object.id, object);
                            }
                        });
                        showHoldTimer();
                        updateTotalPrice();

                        const mainContent = document.querySelector('.main-content');
                        if (mainContent) {
                            mainContent.scrollIntoView({behavior: 'smooth'});
                        }
                    }
                });
            }
        }).render();
    }

    function showSessionExpiredOverlay() {
        if (sessionExpiredOverlay) sessionExpiredOverlay.style.display = 'flex';
    }

    function hideSessionExpiredOverlay() {
        if (sessionExpiredOverlay) sessionExpiredOverlay.style.display = 'none';
    }

    function showHoldTimer() {
        if (holdTimerEl) holdTimerEl.style.display = '';
    }

    function hideHoldTimer() {
        if (!holdTimerEl) return;
        holdTimerEl.style.display = 'none';
        holdTimerEl.textContent = '';
    }

    function setHoldTimerText(text) {
        if (holdTimerEl) holdTimerEl.textContent = text;
    }

    function startHoldCountdown(expiresAtIso) {
        if (!expiresAtIso) {
            hideHoldTimer();
            return;
        }
        const end = Date.parse(expiresAtIso);
        if (isNaN(end)) {
            hideHoldTimer();
            return;
        }
        if (holdTimerInterval) {
            clearInterval(holdTimerInterval);
        }

        const tick = () => {
            const now = Date.now();
            let diff = Math.max(0, Math.floor((end - now) / 1000));
            const mm = String(Math.floor(diff / 60)).padStart(2, '0');
            const ss = String(diff % 60).padStart(2, '0');
            setHoldTimerText(`Бронь истечёт через ${mm}:${ss}`);
            if (diff <= 0) {
                clearInterval(holdTimerInterval);
                setHoldTimerText('Бронь истекла');
            }
        };
        tick();
        holdTimerInterval = setInterval(tick, 1000);
    }

    function tileId(objectId) {
        return `seat-tile-${objectId}`;
    }

    function getSeatParts(object) {
        const sector = object?.category?.label ?? object?.categoryLabel ?? null;
        const section = object?.labels?.section ?? object?.section ?? null;
        const row = object?.row ?? object?.labels?.parent ?? object?.parent?.label ?? null;
        const seat = object?.labels?.own ?? object?.seat ?? object?.label ?? object?.id ?? null;
        return {sector, section, row, seat};
    }

    function getCategoryKey(object) {
        const key = object?.category?.key ?? object?.categoryKey ?? null;
        return key != null ? String(key) : null;
    }

    function findPriceByCategoryKey(categoryKey) {
        if (!categoryKey) return null;
        const prices = Array.isArray(config?.prices) ? config.prices : [];
        const found = prices.find(p => String(p?.category) === String(categoryKey));
        return typeof found?.price === 'number' ? found.price : (found?.price ? Number(found.price) : null);
    }

    function formatPriceValue(price) {
        if (price == null || isNaN(price)) return null;
        const symbol = config?.currencySymbol ?? '';
        return priceFormatter.format(price) + ' ' + symbol;
    }

    function escapeHtml(value) {
        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    function createSeatTile(object) {
        const {sector, section, row, seat} = getSeatParts(object);

        const categoryKey = getCategoryKey(object);
        const price = findPriceByCategoryKey(categoryKey);
        const priceText = formatPriceValue(price);

        const sectorTitle = [sector, section].filter(Boolean).join(' ');
        const line1 = sectorTitle
            ? `<div class="seat-tile__line seat-tile__sector">${escapeHtml(sectorTitle)}</div>`
            : '';

        const rowSeatParts = [];
        if (row) rowSeatParts.push(`Ряд ${row}`);
        if (seat) rowSeatParts.push(`Место ${seat}`);
        const line2 = rowSeatParts.length
            ? `<div class="seat-tile__line seat-tile__row-seat">${escapeHtml(rowSeatParts.join(' • '))}</div>`
            : '';

        const line3 = priceText
            ? `<div class="seat-tile__line seat-tile__price">${escapeHtml(priceText)}</div>`
            : '';

        let labelHtml = `${line1}${line2}${line3}`;
        if (!labelHtml) {
            const fallback = (object.labels?.displayedLabel || object.label || object.id || '');
            labelHtml = `<div class="seat-tile__line">${escapeHtml(fallback)}</div>`;
        }

        const seatIdAttr = escapeHtml(object.id);

        return `
            <div class="seat-tile" id="${tileId(object.id)}">
                <div class="seat-tile__label">${labelHtml}</div>
                <button class="seat-tile__remove" type="button" data-seat-id="${seatIdAttr}" aria-label="Убрать место">×</button>
            </div>
        `;
    }

    function addSeatTile(object) {
        if (!selectedContainer) return;
        const existing = document.getElementById(tileId(object.id));
        if (existing) return;
        selectedContainer.insertAdjacentHTML('beforeend', createSeatTile(object));
    }

    function removeSeatTile(objectId) {
        if (!selectedContainer) return;
        const node = document.getElementById(tileId(objectId));
        if (node && node.parentNode) node.parentNode.removeChild(node);
    }

    if (sessionExpiredBtn) {
        sessionExpiredBtn.addEventListener('click', function () {
            hideSessionExpiredOverlay();
            try {
                if (chart && typeof chart.rerender === 'function') {
                    chart.rerender();
                }
            } catch (e) {
            }
        });
    }

    if (selectedContainer) {
        selectedContainer.addEventListener('click', function (e) {
            const target = e.target;
            if (!(target instanceof Element)) return;
            const btn = target.closest('button.seat-tile__remove');
            if (!btn) return;

            const seatId = btn.getAttribute('data-seat-id');
            if (!seatId) return;

            try {
                if (chart && typeof chart.deselectObjects === 'function') {
                    chart.deselectObjects([seatId]);
                }
            } catch (err) {
                removeSeatTile(seatId);
                selectedIds.delete(seatId);
                selectedObjects.delete(seatId);
                updateTotalPrice();
            }
        });
    }

    function checkAndInit() {
        if (!config || !config.event) {
            return;
        }

        const mobilePlaceholder = document.getElementById('seatsio-placeholder-mobile');
        const desktopPlaceholder = document.getElementById('seatsio-placeholder-desktop');

        if (widgetElement) {
            const chartWrapper = document.getElementById('seatsio-chart-wrapper');
            if (window.innerWidth <= 768) {
                if (mobilePlaceholder) {
                    mobilePlaceholder.appendChild(widgetElement);
                }
                if (chartWrapper) {
                    chartWrapper.style.height = '300px';
                }
            } else if (desktopPlaceholder) {
                desktopPlaceholder.appendChild(widgetElement);
                if (chartWrapper) {
                    chartWrapper.style.height = '600px';
                }
            }
        }

        const sessionKey = `seatsio_expires_at_${config.event}`;
        const expiresAtStr = localStorage.getItem(sessionKey);
        let hasActiveSession = false;

        if (expiresAtStr) {
            const expiresAt = Date.parse(expiresAtStr);
            if (!isNaN(expiresAt) && expiresAt > Date.now()) {
                hasActiveSession = true;
            }
        }

        if (hasActiveSession) {
            showChart();
        }
    }

    checkAndInit();

    const ticketsBtns = document.querySelectorAll('.seatsio-tickets-btn');
    ticketsBtns.forEach(btn => {
        btn.addEventListener('click', function () {
            if (window.seatsioHelper) {
                window.seatsioHelper.showChart();
            }
            if (widgetElement) {
                widgetElement.scrollIntoView({behavior: 'smooth', block: 'start'});
            }
        });
    });

    document.addEventListener('seatsioGoBack', function () {
        if (window.seatsioHelper) {
            window.seatsioHelper.hideChart();
        }
    });
});
